import { defineComponent, ref, watch } from "vue";
import { useRoomStore } from "../../stores/room.mjs";
import { storeToRefs } from "pinia";
import Select from "./base/Select/index.mjs";
import OPtion from "./base/Option/index.mjs";
import { TUIMediaDeviceType } from "@tencentcloud/tuiroom-engine-js";
import useDeviceManager from "../../hooks/useDeviceManager.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DeviceSelect",
  props: {
    deviceType: null,
    onChange: null,
    disabled: { type: Boolean }
  },
  setup(__props) {
    const { deviceType, onChange, disabled = false } = __props;
    const { deviceManager } = useDeviceManager();
    const roomStore = useRoomStore();
    const {
      cameraList,
      microphoneList,
      speakerList,
      currentCameraId,
      currentMicrophoneId,
      currentSpeakerId
    } = storeToRefs(roomStore);
    const deviceList = ref(getDeviceList());
    const currentDeviceId = ref(getInitDeviceId());
    function getInitDeviceId() {
      if (deviceType === "camera") {
        return currentCameraId.value;
      }
      if (deviceType === "microphone") {
        return currentMicrophoneId.value;
      }
      if (deviceType === "speaker") {
        return currentSpeakerId.value;
      }
      return "";
    }
    if (deviceType === "camera") {
      watch(
        currentCameraId,
        (val) => {
          if (currentDeviceId.value !== val) {
            currentDeviceId.value = val;
          }
        },
        { immediate: true }
      );
    }
    if (deviceType === "microphone") {
      watch(
        currentMicrophoneId,
        (val) => {
          if (currentDeviceId.value !== val) {
            currentDeviceId.value = val;
          }
        },
        { immediate: true }
      );
    }
    if (deviceType === "speaker") {
      watch(
        currentSpeakerId,
        (val) => {
          if (currentDeviceId.value !== val) {
            currentDeviceId.value = val;
          }
        },
        { immediate: true }
      );
    }
    function getDeviceList() {
      if (deviceType === "camera") {
        return cameraList;
      }
      if (deviceType === "microphone") {
        return microphoneList;
      }
      if (deviceType === "speaker") {
        return speakerList;
      }
      return [];
    }
    async function handleChange(deviceId) {
      var _a, _b, _c;
      onChange && onChange(deviceId);
      switch (deviceType) {
        case "camera":
          try {
            await ((_a = deviceManager.instance) == null ? void 0 : _a.setCurrentDevice({
              type: TUIMediaDeviceType.kMediaDeviceTypeVideoCamera,
              deviceId
            }));
            roomStore.setCurrentCameraId(deviceId);
          } catch (error) {
            if (cameraList.value.map((item) => item.deviceId).includes(currentCameraId.value)) {
              currentDeviceId.value = currentCameraId.value;
            }
          }
          break;
        case "microphone":
          try {
            await ((_b = deviceManager.instance) == null ? void 0 : _b.setCurrentDevice({
              type: TUIMediaDeviceType.kMediaDeviceTypeAudioInput,
              deviceId
            }));
            roomStore.setCurrentMicrophoneId(deviceId);
          } catch (error) {
            if (microphoneList.value.map((item) => item.deviceId).includes(currentMicrophoneId.value)) {
              currentDeviceId.value = currentMicrophoneId.value;
            }
          }
          break;
        case "speaker":
          try {
            await ((_c = deviceManager.instance) == null ? void 0 : _c.setCurrentDevice({
              type: TUIMediaDeviceType.kMediaDeviceTypeAudioOutput,
              deviceId
            }));
            roomStore.setCurrentSpeakerId(deviceId);
          } catch (error) {
            if (speakerList.value.map((item) => item.deviceId).includes(currentSpeakerId.value)) {
              currentDeviceId.value = currentSpeakerId.value;
            }
          }
          break;
      }
    }
    return { __sfc: true, deviceManager, roomStore, cameraList, microphoneList, speakerList, currentCameraId, currentMicrophoneId, currentSpeakerId, deviceList, currentDeviceId, getInitDeviceId, getDeviceList, handleChange, TuiSelect: Select, TuiOption: OPtion };
  }
});
export {
  _sfc_main as default
};
